var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.banner},[_c('h1',{class:_vm.$style[("banner_" + (_vm.current.name || _vm.current.link))]},[_vm._v("\n    "+_vm._s(_vm.current.title)+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }